import React, { Component } from 'react';
import { oneOfType, bool, number } from 'prop-types';
import { localStorage } from 'dibs-browser-storage';
import { FormattedMessage } from 'react-intl';

import { StarRating } from 'dibs-elements/exports/StarRating';
import { Tooltip } from 'dibs-elements/exports/Tooltip';
import { TooltipHeader } from 'dibs-elements/exports/TooltipHeader';
import { Button } from 'dibs-elements/exports/Button';
import { orderFeedbackEvent } from '../../tracking/orderFeedbackTracking';

import styles from './PdpRespDealerDetailsFeedbackStat.scss';

// export for testing
export const LOCAL_STORAGE_KEY = 'user-has-seen-pdp-review-tooltip';

class PdpRespDealerDetailsFeedbackStat extends Component {
    constructor(props) {
        super(props);
        this.state = { tooltipIsOpen: false };
        this.openToolTip = this.openToolTip.bind(this);
        this.closeToolTip = this.closeToolTip.bind(this);
    }

    componentDidMount() {
        const userHasSeenTooltip = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (!userHasSeenTooltip) {
            this.setState({ tooltipIsOpen: true });
            localStorage.setItem(LOCAL_STORAGE_KEY, true);
        }
    }

    openToolTip() {
        orderFeedbackEvent({
            action: 'whats this clicked',
            label: 'pdp',
        });
        this.setState(() => ({ tooltipIsOpen: true }));
    }

    closeToolTip() {
        this.setState(() => ({ tooltipIsOpen: false }));
    }

    render() {
        const { feedbackRating } = this.props;
        const { tooltipIsOpen } = this.state;

        return (
            <div className={styles.ratingContainer}>
                <StarRating rating={feedbackRating} size="small" />
                <div className={styles.ratingFraction}>
                    {feedbackRating ? (
                        <FormattedMessage
                            id="PdpRespDealerDetailsFeedbackStat.feedbackRating"
                            defaultMessage={`{feedbackRating, number} / 5`}
                            values={{ feedbackRating }}
                        />
                    ) : (
                        <FormattedMessage
                            id="PdpRespDealerDetailsFeedbackStat.noReviews"
                            defaultMessage="No Reviews Yet"
                        />
                    )}
                </div>
                <div className={styles.learnMore}>
                    <span
                        data-tn="order-feedback-stat-tooltip-trigger"
                        className={styles.learnMoreTrigger}
                        onClick={this.openToolTip}
                    >
                        <FormattedMessage
                            id="PdpRespDealerDetailsFeedbackStat.tooltipTrigger"
                            defaultMessage="What's this?"
                        />
                    </span>
                    <Tooltip direction="right" isVisible={tooltipIsOpen}>
                        <TooltipHeader
                            title={
                                <FormattedMessage
                                    id="PdpRespDealerDetailsFeedbackStat.tooltipTitle"
                                    defaultMessage="Reviews on Sellers"
                                />
                            }
                        />
                        <div>
                            <FormattedMessage
                                id="PdpRespDealerDetailsFeedbackStat.tooltipCopy"
                                defaultMessage="Now you can see customer ratings and reviews of a seller. Please note that volume may be low, as this is a new feature."
                            />
                        </div>
                        <div className={styles.buttonContainer}>
                            <Button
                                data-tn="order-feedback-stat-tooltip-close"
                                size="small"
                                type="secondary"
                                onClick={this.closeToolTip}
                            >
                                <FormattedMessage
                                    id="PdpRespDealerDetailsFeedbackStat.tooltipClose"
                                    defaultMessage="close"
                                />
                            </Button>
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    }
}

PdpRespDealerDetailsFeedbackStat.propTypes = {
    feedbackRating: number,
};

export default PdpRespDealerDetailsFeedbackStat;
